/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import { InsightsAndTrendsModel } from "../../models/insights-and-trends-model";

export interface AnalyticsInsightsAndTrendsGetParams {
    questionnaireGuid: string;
    version?: number | undefined;
}

export function analyticsInsightsAndTrendsGet(http: HttpClient, rootUrl: string, params: AnalyticsInsightsAndTrendsGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<InsightsAndTrendsModel>> {
    const rb = new RequestBuilder(rootUrl, analyticsInsightsAndTrendsGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.path('questionnaireGuid', params.questionnaireGuid, {"style":"simple"});

    if (params.version) {
        rb.query('version', params.version);
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<InsightsAndTrendsModel>;
        })
    );
}

analyticsInsightsAndTrendsGet.PATH = '/api/v1/analytics/questionnaires/{questionnaireGuid}/insights-and-trends';
